import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import React from 'react'

interface IProps {
  headerRow: React.ReactFragment
  id?: string
  items: any[]
  rowRenderer: (rowItem: any) => React.ReactFragment
}

const SimpleTable = (props: IProps) => {
  const { items, headerRow, rowRenderer } = props

  return (
    <Table id={props.id}>
      <TableHead>
        <TableRow>{headerRow}</TableRow>
      </TableHead>
      <TableBody>
        {items.map((item, idx) => (
          <TableRow key={`item_${idx}`}>{rowRenderer(item)}</TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default SimpleTable
